import React from 'react';
import { Program, School, Country, City, DocumentLead } from 'app/types';
import Loader from 'common/components/Loader/Loader';
import styles from './Index.module.scss';
import Pagination from 'common/components/Pagination/Pagination';
import Table from 'common/components/Table/Table';

interface IndexProps {
  objects?: Program[] | School[] | Country[] | City[] | DocumentLead[];
  isLoading: boolean;
  pagination: {
    pages: number;
    current: number;
    onChange: (page: number) => void;
  };
  columns: string[];
  csv?: string;
}

const Index = ({
  objects,
  isLoading,
  pagination,
  columns,
  csv,
}: IndexProps): React.ReactElement => {
  if (isLoading) return <Loader />;
  return (
    <div className={styles.indexContainer}>
      <div className={styles.cardListContainer} id="exploreProgramList">
        <Table columns={columns} data={objects} csv={csv} />
      </div>
      <Pagination className={styles.pagination} {...pagination} />
    </div>
  );
};

export default Index;
